import React from 'react'

export default function SuperAdminHelpDesk() {
  return (
    <div>SuperAdminHelpDesk</div>
  )
}
